import { useEffect, useState } from "react";
import DisplayContent from "../../MPP-Common-SPA/components/DynamicForm/Forms/DisplayContent";
import { GoabModal, GoabButton, GoabButtonGroup } from "@abgov/react-components";

export const CopyFromPreviousApplication = ({
  allowCopyFromPreviousApplication = false,
  previousApplication,
  getResourceValue,
  copyApplicationData,
  userApplicationData,
  refuseCopyApplicationData,
  currentStep,
}) => {
  const [showModal, setShowModal] = useState(false);
  const { isFirstApplicationStep } = currentStep;

  useEffect(() => {
    const { copyApplied = false} = userApplicationData ?? {};
    if (allowCopyFromPreviousApplication && isFirstApplicationStep && !copyApplied) {
      setShowModal(true);
    }
  }, [allowCopyFromPreviousApplication, currentStep, userApplicationData]);

  const handleStartFresh = () => {
    refuseCopyApplicationData();
    setShowModal(false);
  };

  const handleReuse = () => {
    copyApplicationData({ applicationToCopy: previousApplication });
    setShowModal(false);
  };

  return (
    <GoabModal
      testId="copy-from-previous-application-modal"
      calloutVariant="information"
      heading={getResourceValue({
        key: "RESOURCES@global.reuseApplication.header",
      })}
      open={showModal}
      actions={
        <GoabButtonGroup alignment="end">
          <GoabButton
            type="secondary"
            name="start-freh"
            testId="copy-from-previous-application-start-fresh"
            onClick={() => handleStartFresh()}
          >
            {getResourceValue({
              key: "RESOURCES@global.reuseApplication.startFresh",
            })}
          </GoabButton>
          <GoabButton
            type="primary"
            name="reuse-information"
            testId="copy-from-previous-application-reuse-information"
            onClick={() => handleReuse()}
          >
            {getResourceValue({
              key: "RESOURCES@global.reuseApplication.reuseInformation",
            })}
          </GoabButton>
        </GoabButtonGroup>
      }
    >
      <DisplayContent
        content={getResourceValue({
          key: "RESOURCES@global.reuseApplication.content",
        })}
      />
    </GoabModal>
  );
};
